import React, { useState, useRef } from 'react'
import classnames from 'classnames/bind'
import { isEmpty } from 'lodash-es'
import { useFormikContext } from 'formik'
import { useTranslation } from 'next-i18next'
import scrollIntoView from 'smooth-scroll-into-view-if-needed'

// Components
import FieldItem from '@/components/common/livemallclub/Form/components/FieldItem'
import Form from '@/components/common/livemallclub/Form'
import Button from '@/components/common/livemallclub/Button'

// Constants
import { FIELD_VARIANT } from '@/constants/fieldVariant'
import { isClientSideShopApp } from '@/utils/navigator'

// Styles
import styles from './style.module.scss'
import { useAppDispatch } from '@/redux/hooks'
import { setIsInputFocused } from '@/redux/reducers/common'

const cx = classnames.bind(styles)

const ShoppingCart = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [hasValidated, setHasValidated] = useState(false)
  const actionRef = useRef<HTMLDivElement>(null)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { values: confirmationForm, setFieldValue, setValues, validateField, errors, setTouched, handleSubmit }: any = useFormikContext()

  const sharedInputProps = isClientSideShopApp
    ? {
        onFocus: () => {
          dispatch(setIsInputFocused(true))
          setTimeout(() => {
            if (actionRef.current) {
              scrollIntoView(actionRef.current, {
                block: 'center',
                inline: 'nearest',
              })
            }
          }, 100)
        },
        onBlur: () => {
          dispatch(setIsInputFocused(false))
          setTimeout(() => {
            if (actionRef.current) {
              scrollIntoView(actionRef.current, {
                block: 'center',
                inline: 'nearest',
              })
            }
          }, 100)
        },
      }
    : null

  const handleButtonClick = async () => {
    // 觸發所有欄位的驗證
    await setTouched({
      name: true,
      email: true,
    })

    // 標記已經進行過驗證
    setHasValidated(true)

    // 執行原本的提交邏輯
    handleSubmit()
  }

  return (
    <>
      <div className={cx('user-data-form-content')}>
        <div className={cx('user-data-form-item')}>
          <div className={cx('user-data-form-item-title')}>{t('Landing_Page_Invitation_User_Data_Form_Item_1_Title')}</div>
          <FieldItem
            className={cx('common-component-field-item', {
              'common-component-field-item--has-error': hasValidated && !isEmpty(errors) && !isEmpty(errors.name),
            })}
            name='name'
            title=''
            showError={false}
            showCloseButton={false}
            variant={FIELD_VARIANT.FILLED}
          >
            <Form.InputField className={cx('common-component-input')} {...sharedInputProps} />
          </FieldItem>
        </div>
        <div className={cx('user-data-form-item')}>
          <div className={cx('user-data-form-item-title')}>{t('Landing_Page_Invitation_User_Data_Form_Item_2_Title')}</div>
          <FieldItem
            className={cx('common-component-field-item', {
              'common-component-field-item--has-error': hasValidated && !isEmpty(errors) && !isEmpty(errors.email),
            })}
            name='email'
            title=''
            showError={false}
            showCloseButton={false}
            variant={FIELD_VARIANT.FILLED}
          >
            <Form.InputField className={cx('common-component-input')} {...sharedInputProps} />
          </FieldItem>
        </div>
      </div>
      <div ref={actionRef} className={cx('user-data-form-action')}>
        {hasValidated && !isEmpty(errors) && <div className={cx('user-data-form-error-message')}>{errors.name || errors.email}</div>}

        <Button
          onClick={handleButtonClick}
          className={cx('user-data-form-action-submit')}
          theme={'major'}
          size={'lg'}
          disabled={isEmpty(confirmationForm['name']) || isEmpty(confirmationForm['email'])}
        >
          {t('Common_Submit')}
        </Button>
      </div>
    </>
  )
}

export default ShoppingCart
